import { useEffect, useState } from "react";
import Button from "../Component/Common/Button";
import Logo from "../assets/images/MetubeLogo.png";
import Input from "../Component/Common/Input";
import { connect } from "react-redux";
import { projectName } from "../util/config";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiInstance } from "../util/api-new";
import { setToast } from "../util/toast";

function SetPassword() {
  const [query, setQuery] = useSearchParams();

  useEffect(() => {
    let account = query.get("account");
    let id = query.get("id");

    localStorage.setItem("reset", JSON.stringify({ account, id }));
    setQuery({});
  }, []);

  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();

  const [error, setError] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const handleSubmit = async () => {
    if (!newPassword || !confirmPassword || newPassword !== confirmPassword) {
      let error = {};
      if (!newPassword) error.newPassword = "New Password Is Required !";
      if (!confirmPassword)
        error.confirmPassword = "Confirm Password Is Required !";
      if (newPassword !== confirmPassword)
        error.confirmPassword = "Passwords do not match!";
      return setError({ ...error });
    } else {
      let reset = JSON.parse(localStorage.getItem("reset"));
      let changePasswordData = {
        newPassword: newPassword,
        confirmPassword: confirmPassword,
        account: reset.account,
        id: reset.id,
      };

      apiInstance.put("reset-password", changePasswordData).then((res) => {
        if (res.status) {
          const user = JSON.parse(localStorage.getItem("reset"));
          localStorage.removeItem("reset");
          setToast("success", "Password reset successfully!");
          if (user.account === "org") {
            navigate("/org/login", { replace: true });
          } else {
            navigate("/login", { replace: true });
          }
        }
      });
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };
  return (
    <div className="reset-password">
      <div className="dashboardHeader primeHeader mb-3 p-0">
        <div className="login-page">
          <div className="row">
            <div className="col-12 d-flex justify-content-center align-items-center">
              <div className="login-page-box ">
                <div className="login-box-img">
                  <img src={Logo} />
                  <h5>{projectName}</h5>
                </div>
                <div className="login-form">
                  <h6>Change Password</h6>
                  <Input
                    label={`New Password`}
                    id={`newPassword`}
                    type={`password`}
                    value={newPassword}
                    errorMessage={error.newPassword && error.newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          newPassword: `New Password Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          newPassword: "",
                        });
                      }
                    }}
                    onKeyPress={handleKeyPress}
                  />
                  <Input
                    label={`Confirm Password`}
                    id={`confirmPassword`}
                    type={`password`}
                    value={confirmPassword}
                    errorMessage={
                      error.confirmPassword && error.confirmPassword
                    }
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          confirmPassword: `Confirm Password Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          confirmPassword: "",
                        });
                      }
                    }}
                    onKeyPress={handleKeyPress}
                  />
                  <div className="d-flex justify-content-center w-100">
                    <Button className={"mt-2 rounded"} onClick={handleSubmit}>
                      Change Password
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null, {})(SetPassword);
